var React = require('react');

function Suitcase (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M80 480h48V128H80zm304-352v352h48V128z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M336 32H176a48 48 0 0 0-48 48v400h256V80a48 48 0 0 0-48-48zm-16 96H192V96h128zm144 0h-32v352h32a48 48 0 0 0 48-48V176a48 48 0 0 0-48-48zM0 176v256a48 48 0 0 0 48 48h32V128H48a48 48 0 0 0-48 48z","className":"fa-primary","key":2})]);
}

Suitcase.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Suitcase;

Suitcase.default = Suitcase;
